import { render, staticRenderFns } from "./IconTick.vue?vue&type=template&id=20f5f25f&scoped=true"
import script from "./IconTick.vue?vue&type=script&lang=js"
export * from "./IconTick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5f25f",
  null
  
)

export default component.exports